// frontend/modules/template/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import TemplateManagementView from './views/TemplateManagementView';
import { ContextScriptListView } from './views/ContextScriptListView';
import { ContextScriptEditView } from './views/ContextScriptEditView';
import { ContextScriptViewView } from './views/ContextScriptViewView';
import { ContextTransformationView } from './views/ContextTransformationView';
import { NotificationsLayout } from './components/NotificationsLayout';

export const templateRoutes: RouteObject[] = [
    {
        path: '/notifications',
        element: <NotificationsLayout />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: 'templates',
                element: <TemplateManagementView />,
            },
            {
                path: 'context-scripts',
                element: <ContextScriptListView />,
            },
            {
                path: 'context-scripts/new',
                element: <ContextScriptEditView />,
            },
            {
                path: 'context-scripts/edit/:id',
                element: <ContextScriptEditView />,
            },
            {
                path: 'context-scripts/view/:id',
                element: <ContextScriptViewView />,
            },
            {
                path: 'context-transformation',
                element: <ContextTransformationView />,
            }
        ]
    }
];